import { render, staticRenderFns } from "./PASSPORT.vue?vue&type=template&id=53f88d74&"
import script from "./PASSPORT.vue?vue&type=script&lang=js&"
export * from "./PASSPORT.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports